module.exports = "/_next/static/images/e5-2-3cbbb467e6927edfae7a8e6ce19e83bd.jpg.webp";